import axiosInstance from "../axiosInstance";

export interface StationPerformance {
  station_id: string;
  station_name: string;
  total_sessions: number;
  consumed_kwh: number;
  total_revenue: number;
  avg_revenue_per_session: number;
  total_chargers: number;
  active_chargers: number;
}

export const fetchStationPerformance = async (
  tenantId: string,
  startDate?: string,
  endDate?: string
): Promise<StationPerformance[]> => {
  try {
    const params: Record<string, string> = {};
    if (startDate) params.start_date  = startDate;
    if (endDate) params.end_date = endDate;

    const response = await axiosInstance.get(
      `api/analytics/tenants/${tenantId}/analytics/station-performance`,
      { params }
    );

    return response.data.items;
  } catch (error) {
    console.error("Error fetching station performance:", error);
    throw error;
  }
};
